import { render, staticRenderFns } from "./CommentsActual.vue?vue&type=template&id=eff74a76&"
import script from "./CommentsActual.vue?vue&type=script&lang=js&"
export * from "./CommentsActual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports